import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { GalleryCard } from './GalleryCard';
import StarField from './StarField';

const Gallery = () => {
  const images = [
    {
      image: '/data/Town_01.jpg',
      title: 'Social IMGs',
      subtitle: 'Ho Chi Minh City'
    },
    {
      image: '/data/Town_02.jpg',
      title: 'Social IMGs',
      subtitle: 'New York'
    },
    {
      image: '/data/Town_03.jpg',
      title: 'Social IMGs',
      subtitle: 'Istanbul'
    },
    {
      image: '/data/Dinner.png',
      title: 'Social IMGs',
      subtitle: 'Dinner'
    },
    {
      image: '/data/Dreamer3.png',
      title: 'Social IMGs',
      subtitle: 'Dreamer'
    },
    {
      image: '/data/Emotion.png',
      title: 'Social IMGs',
      subtitle: 'Emotion'
    },
    {
      image: '/data/Fighter.png',
      title: 'Social IMGs',
      subtitle: 'Fighter'
    },
    {
      image: '/data/Personalities.png',
      title: 'Social IMGs',
      subtitle: 'Personalities'
    },
    {
      image: '/data/Sleep.png',
      title: 'Social IMGs',
      subtitle: 'Sleep'
    },
    {
      image: '/data/Time.png',
      title: 'Social IMGs',
      subtitle: 'Time'
    },
    {
      image: '/data/Working.png',
      title: 'Social IMGs',
      subtitle: 'Working'
    }
  ];

  return (
    <div className="min-h-screen bg-black relative">
      <StarField />
      
      <div className="container mx-auto px-4 py-8">
        <Link 
          to="/"
          className="inline-flex items-center text-white opacity-80 hover:opacity-100 transition-opacity duration-300 mb-8"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Back to Home
        </Link>
        
        <h1 className="text-white text-3xl font-bold mb-8">SOMNIUMCRA Gallery</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 gap-y-12">
          {images.map((item, index) => (
            <GalleryCard
              key={index}
              image={item.image}
              title={item.title}
              subtitle={item.subtitle}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Gallery;